export default {
    currentPage: 0,
    programmePage: 1,
    presentationPage: 0,
    JournalismPage: 0,
    AboutUSPage: 1,
    servicePage: 1,
    presentationIds: 0,

}